import { NavigationService } from "@/shared/services/NavigationService";
import { Component, Vue, Inject, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { AuthService } from "./services/AuthService";
import { Http } from "@status/codes";
import { LOGIN_CONSTANTS, WELCOME_MSG } from "./constants/LoginConstants";
import { NotificationService } from "../Notification/services/NotificationService";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  MESSAGE_ERROR,
  LOCAL_STORAGE
} from "../../shared/constants/FormConstants";
import { Utils } from "../../shared/utils/utils";
import {
  GENERAL_CONSTANTS,
  STORE_CONSTANTS
} from "../../shared/constants/GeneralConstants";
import store from "../../store";
import { NotificationMessage } from "../Notification/models/NotificationMessage";
import { AxiosError } from "axios";
import Recover from "./Recover/Recover.vue";

@Component({
  name: "Login",
  components: {
    Recover
  }
})
export default class Login extends Vue {
  @Inject() authService!: AuthService;
  @Inject() notificationService!: NotificationService;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;
  secClassBtn = STYLE_CLASSES.SECONDARY_BTN;

  PAGE_TITLE = LOGIN_CONSTANTS.PAGE_TITLE;
  LABEL_USER = `${LOGIN_CONSTANTS.LABEL.EMAIL} o ${LOGIN_CONSTANTS.LABEL.ID}`;
  LABEL_PASSWORD = LOGIN_CONSTANTS.LABEL.PASSWORD;
  BTN_USER_PASSWORD = LOGIN_CONSTANTS.BUTTON.USER_PASSWORD;
  BTN_GOOGLE = LOGIN_CONSTANTS.BUTTON.GOOGLE;
  BTN_REGISTER = LOGIN_CONSTANTS.BUTTON.REGISTER;
  BTN_SINGME = LOGIN_CONSTANTS.BUTTON.SINGME;
  BTN_FORGOT_PASSWORD = LOGIN_CONSTANTS.BUTTON.FORGOT_PASSWORD;
  BTN_RECOVERY_PASSWORD = LOGIN_CONSTANTS.BUTTON.RECOVERY_PASSWORD;
  WELCOME_MSG_LOGINN = WELCOME_MSG;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  NEUMO_PLATFORM = LOGIN_CONSTANTS.NEUMO_PLATFORM;
  PATIENT_PORTAL = LOGIN_CONSTANTS.PATIENT_PORTAL;
  PLATAFORMA_NEUMOMED = LOGIN_CONSTANTS.PLATAFORMA_NEUMOMED;
  PLATAFORMA_PACIENTE = LOGIN_CONSTANTS.PLATAFORMA_PACIENTE;
  MODAL_REDIRECT_TITLE = LOGIN_CONSTANTS.MODAL_REDIRECT_TITLE;

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  inputUser = "";
  inputPassword = "";
  loginForm = false;
  validating = false;
  loginRedirectPlatformModal = false;
  customToken = "";
  viewModal = false;

  async closeDialog() {
    this.viewModal = false;
    // reload form
  }
  @Watch("loginForm")
  onLoginFormChange() {
    this.loginForm = this.inputUser.length > 0 && this.inputPassword.length > 0;
  }

  async onLogin() {
    this.validating = true;
    try {
      const responseData = await this.authService.login(
        this.inputUser,
        this.inputPassword
      );

      if (responseData.code == Http.Found && responseData.data) {
        this.customToken = responseData.data.userToken;
        const user = await this.authService.loginByToken(
          responseData.data.userToken
        );

        if (user) {
          await this.authService.setClaims(
            user.user,
            responseData.data.views,
            responseData.data.access,
            responseData.data.searcher
          );

          const token = await user.user?.getIdToken();
          const currentUser = user.user?.uid;
          if (token) {
            const roles = localStorage.getItem(LOCAL_STORAGE.ROLE)?.split(",");
            this.initialSettings(token as string, currentUser);
            if (
              roles &&
              roles.includes(LOGIN_CONSTANTS.ROLE_PATIENT) &&
              roles.length == 1
            ) {
              window.open(
                `${process.env.VUE_APP_PATIENT_PORTAL}/loginFromToken?token=${this.customToken}`,
                "_self"
              );
            } else if (this.isExternalRole(roles)) {
              this.redirectPlatform(LOGIN_CONSTANTS.NEUMO_PLATFORM);
            } else {
              this.loginRedirectPlatformModal = true;
            }
          }
        }
      } else {
        if (responseData.code === Http.BadRequest) {
          Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
        } else {
          Snackbar.popInfo(responseData.message);
        }
      }
    } catch (e) {
      if ((e as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(LOGIN_CONSTANTS.SNACKBAR.USER_NOT_FOUND);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    this.validating = false;
  }

  initialSettings(token: string, currentUser: string | undefined) {
    this.authService.setTokenAndUser(token, currentUser);
    this.getNotifications();
    this.getCountryIp();
  }

  onValidate() {
    this.onLoginFormChange();
    if (this.loginForm) {
      this.inputUser = this.inputUser.trim();
      this.onLogin();
    } else {
      Snackbar.popWarning(LOGIN_CONSTANTS.SNACKBAR.EMPTY);
    }
  }

  redirectToRegister() {
    NavigationService.navigateByPath(LOGIN_CONSTANTS.URL_TO_REGISTER);
  }

  async googleLogin() {
    try {
      const responseLogin = await this.authService.loginWithGoogle();

      if (responseLogin.user && responseLogin.user.email) {
        this.validating = true;
        const validUser = await this.authService.validateUser(
          responseLogin.user.uid,
          responseLogin.user.email
        );

        if (validUser.code === Http.Found && validUser.data) {
          this.customToken = validUser.data.userToken;
          const user = await this.authService.loginByToken(this.customToken);

          await this.authService.setClaims(
            user.user,
            validUser.data.views,
            validUser.data.access,
            validUser.data.searcher
          );
          const token = await user.user?.getIdToken();
          const currentUser = user.user?.uid;
          if (token) {
            const roles = localStorage.getItem(LOCAL_STORAGE.ROLE)?.split(",");
            this.initialSettings(token, currentUser);
            if (
              roles &&
              roles.includes(LOGIN_CONSTANTS.ROLE_PATIENT) &&
              roles.length == 1
            ) {
              window.open(
                `${process.env.VUE_APP_PATIENT_PORTAL}/loginFromToken?token=${this.customToken}`,
                "_self"
              );
            } else if (this.isExternalRole(roles)) {
              this.redirectPlatform(LOGIN_CONSTANTS.NEUMO_PLATFORM);
            } else {
              this.loginRedirectPlatformModal = true;
            }
          }
        } else {
          Snackbar.popInfo(validUser.message);
        }
        this.validating = false;
      } else {
        this.authService.invalidEmail();
        Snackbar.popError(LOGIN_CONSTANTS.SNACKBAR.BAD_LOGIN);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? LOGIN_CONSTANTS.SNACKBAR.USER_NOT_FOUND
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getNotifications() {
    const uid = localStorage.getItem("UID");

    if (uid) {
      let notifications: NotificationMessage[] = [];
      try {
        const response = await this.notificationService.getNotificationsByUser(
          uid
        );

        if (response.code === Http.Found && response.data !== undefined) {
          notifications = response.data;
        } else {
          notifications = [];
        }
      } catch (error) {
        notifications = [];
      }
      store.commit(STORE_CONSTANTS.NOTIFICATIONS, notifications);
    }
  }

  isExternalRole(roles?: string[]): boolean {
    return (
      roles?.some(role => role.trim().toUpperCase() === "EXTERNO") ?? false
    );
  }

  async getCountryIp() {
    try {
      const countryCode = await Utils.getIpCountry();
      if (countryCode) {
        localStorage.setItem(LOCAL_STORAGE.COUNTRY, countryCode);
      } else {
        Snackbar.popError(MESSAGE_ERROR.COUNTRY_NOT_FOUND);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  redirectPlatform(platform: string) {
    if (platform === LOGIN_CONSTANTS.NEUMO_PLATFORM) {
      NavigationService.navigateByPath(Utils.getUserHomePath());
      Snackbar.popSuccess(
        LOGIN_CONSTANTS.SNACKBAR.WELCOME +
          localStorage.getItem(LOCAL_STORAGE.USER_NAME)
      );
      return;
    }

    window.open(
      `${process.env.VUE_APP_PATIENT_PORTAL}/loginFromToken?token=${this.customToken}`,
      "_self"
    );
  }
}
